// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

// import "babel-polyfill";
import {findPolyfill} from '../_scripts/_helper';
import $ from 'jquery';
import PrimaryMenu from '../_modules/molecules/primary-menu/primary-menu';
import SiteHeader from '../_modules/organisms/site-header/site-header';
import UpcomingProgrammes from '../_modules/molecules/upcoming-programmes/upcoming-programmes';
import HomeEvents from '../_modules/molecules/home-events/home-events';
import BackToTop from '../_modules/atoms/back-to-top/back-to-top';
import Notification from '../_modules/atoms/notification/notification';
import StandardContent from '../_modules/organisms/standard-content/standard-content';
import Sidebar from '../_modules/organisms/sidebar/sidebar';
import Filter from '../_modules/molecules/filter/filter';
import ProductCategory from '../_modules/organisms/product-category/product-category';
import Cart from '../_modules/organisms/cart/cart';

$(() => {
  //activate the polyfill for es6 array helper - find
  findPolyfill();

  new PrimaryMenu();
  new SiteHeader();
  new UpcomingProgrammes();
  new HomeEvents();
  new BackToTop();
  // new Notification();
  new Sidebar();
  new StandardContent();
  new Filter();
  new ProductCategory();
  new Cart();
});
